import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteAdminFarmOrganicFertilizerProduction } from "services";

import { GET_ADMIN_FARM_ORGANIC_FERTILIZER_PRODUCTION, GET_FARM_ORGANIC_FERTILIZER_PRODUCTION } from "consts";

export const useDeleteAdminFarmOrganicFertilizerProduction = ({ farmId }: { farmId: string }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteAdminFarmOrganicFertilizerProduction,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_ADMIN_FARM_ORGANIC_FERTILIZER_PRODUCTION, farmId] });
      queryClient.invalidateQueries({ queryKey: [GET_FARM_ORGANIC_FERTILIZER_PRODUCTION, farmId] });
    },
  });
};
